module.exports = __webpack_public_path__ + "img/inst6.9b5985bf.png";